import { useAppSelector } from "../../../lib/redux/hooks"
import { ListItemCA } from "./item/item"

export function CartellaAziendaleHistoryList() {
    const cartellaAziendaleState = useAppSelector(state => state.cartellaAziendale)
    const historyDetails = cartellaAziendaleState.historyCFDetailsUpdateRequest

    const missingAttachmentItems = historyDetails
        .filter(detail => detail.entryProtocolAttachmentId)
        .filter(detail => !cartellaAziendaleState.cartelleAziendali.some(ca => ca.id === detail.entryProtocolAttachmentId))
        .reduce((acc, detail) => {
            if (acc.some(item => item.id === detail.entryProtocolAttachmentId)) {
                return acc
            }

            acc.push({
                id: detail.entryProtocolAttachmentId,
                code: cartellaAziendaleState.cartelleAziendali.length + acc.length + 1,
                attachmentName: detail.entryProtocolDescription || 'Protocollo',
                protocolDetailIds: []
            })
            return acc
        }, [] as typeof cartellaAziendaleState.cartelleAziendali)

    const attachmentRows = [...cartellaAziendaleState.cartelleAziendali, ...missingAttachmentItems]

    return (
        <div>
            {
                attachmentRows.map((ca, index) => (
                    <div className="pb-3" key={ca.id || `${ca.code}-${index}`}>
                        <ListItemCA
                            historyView={true}
                            code={ca.code}
                            id={ca.id || ''}
                            title={ca.attachmentName}
                            numOfDetails={historyDetails.filter(det => det.entryProtocolAttachmentId === ca.id).length}
                            protocolIds={historyDetails.filter(det => det.entryProtocolAttachmentId === ca.id).map(d => d.id)}
                        />
                    </div>
                ))
            }
            {
                attachmentRows.length === 0 && (
                    <div className="rounded-[14px] border border-[#E5E7EB] bg-white px-5 py-6 text-sm text-[#6B7280]">
                        Nessun protocollo disponibile nello storico.
                    </div>
                )
            }
        </div>
        
    )
}